export default "/images/57c18b1fbdff738e34aa6f3a37d17ce2.avif";